import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../../components/SEO";
import img47 from "../../../assets/img47.jpg";
import img48 from "../../../assets/img48.webp";
import img49 from "../../../assets/img49.webp";
import img50 from "../../../assets/img50.jpg";
import img51 from "../../../assets/img51.png";
import img53 from "../../../assets/img53.webp";
import img54 from "../../../assets/img54.webp";
import img52 from "../../../assets/img52.jpeg";
import img55 from "../../../assets/img55.jpeg";
import img56 from "../../../assets/img56.jpg";
import img57 from "../../../assets/img57.jpeg";
import img58 from "../../../assets/img58.jpeg";
import img59 from "../../../assets/img59.jpeg";
import img60 from "../../../assets/img60.jpeg";
import img61 from "../../../assets/img61.jpeg";
import img62 from "../../../assets/img62.jpeg";
import img63 from "../../../assets/img63.webp";

const CaseStudies = () => {
  const siteContainer = "mx-auto w-full max-w-[1380px] px-4 sm:px-6 lg:px-10";

  return (
    <>
      <SEO
        title="Études de cas et histoires de succès en assurance – einsured.ca"
        description="Découvrez les études de cas d’einsured.ca et comment nos conseils d’experts ont aidé des clients au Canada grâce à des solutions d’assurance adaptées."
        keywords="Études de cas d'assurance, histoires de succès en assurance-vie, approbation d'assurance pour sclérose en plaques, assurance-vie diabète canada"
      />
      {/* HERO SECTION */}
      <section
        className="relative min-h-[60vh] sm:min-h-[70vh] md:min-h-[80vh] flex items-center justify-center md:justify-start bg-cover bg-top"
        style={{
          backgroundImage: `url(${img47})`,
          backgroundPosition: "center top",
        }}
      >
        <div className="absolute inset-0 bg-black/20" />

        <div
          className={`relative z-10 w-full ${siteContainer} pt-20 sm:pt-24 md:pt-28`}
        >
          <div className="max-w-xl bg-white/95 rounded-[2.5rem] shadow-lg px-6 sm:px-10 py-8 sm:py-10">
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#49628b] mb-3 leading-tight">
              Études de cas
            </h1>

            <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">
              Bienvenue dans la section Études de cas d&apos;einsured.ca
            </h2>

            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              Chez einsured.ca, nous sommes fiers de notre vaste expérience et
              de notre expertise approfondie dans la navigation dans le monde
              complexe de l'assurance. Nous croyons en la transparence et au
              pouvoir des exemples concrets pour illustrer la valeur que nous
              apportons à nos clients. Ci-dessous, vous trouverez une sélection
              d'études de cas qui montrent notre capacité à fournir des solutions
              d'assurance adaptées et efficaces dans divers secteurs et types de
              clients.
            </p>
          </div>
        </div>
      </section>

      {/* CASE STUDY 1 */}
      <section className="py-20 bg-white text-gray-900">
        <div className={siteContainer}>
          <div className="text-center mb-12">
            <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-6 py-2 rounded-full">
              Étude de cas 1
            </span>
          </div>

          {/* Two Cards Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-stretch">
            {/* LEFT CARD */}
            <div className="relative bg-[#4B638A] rounded-[28px] p-6 sm:p-8 text-white flex flex-col">
              <div className="absolute left-8 top-0 -translate-y-1/2">
                <span className="inline-flex items-center bg-[#00c6ff] text-white font-bold px-7 py-2 rounded-full border-2 border-white/80 shadow">
                  Client
                </span>
              </div>

              <div className="flex flex-col flex-1 pt-6">
                {/* Inner White Box */}
                <div className="bg-white text-[#49628b] rounded-[22px] p-6 sm:p-8 shadow-md flex-1">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-4 text-sm sm:text-base">
                    <p>
                      <span className="text-gray-500 font-medium">Âge</span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg">
                        41
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Condition
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        Chirurgie de perte de poids
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Approbation
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">7 jours</span>
                    </p>
                  </div>

                  <div className="mt-6 grid grid-cols-1 sm:grid-cols-[minmax(0,1fr)_auto] gap-4 items-end">
                    <p>
                      <span className="text-gray-500 font-medium">
                        Analyse des besoins
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg leading-snug">
                        Assurance-vie sans examen médical
                        <br className="hidden sm:block" />
                        souscrite
                      </span>
                    </p>

                    <span className="inline-block bg-[#00c6ff] text-white font-semibold text-xs sm:text-sm px-5 py-2 rounded-full text-center shadow-sm">
                      sans question de poids
                    </span>
                  </div>
                </div>

                {/* Image */}
                <div className="mt-6 bg-white rounded-[22px] p-2 shadow-sm">
                  <div className="rounded-[18px] overflow-hidden">
                    <img
                      src={img48}
                      alt="Client 1"
                      className="w-full h-[240px] sm:h-[270px] md:h-[300px] object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* RIGHT CARD */}
            <div className="relative bg-[#4B638A] rounded-[28px] p-6 sm:p-8 text-white flex flex-col">
              <div className="absolute left-8 top-0 -translate-y-1/2">
                <span className="inline-flex items-center bg-[#00c6ff] text-white font-bold px-7 py-2 rounded-full border-2 border-white/80 shadow">
                  Client
                </span>
              </div>

              <div className="flex flex-col flex-1 pt-6">
                {/* Inner White Box */}
                <div className="bg-white text-[#49628b] rounded-[22px] p-6 sm:p-8 shadow-md flex-1">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-6 gap-y-5 text-sm sm:text-base">
                    <p>
                      <span className="text-gray-500 font-medium">Âge</span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg">
                        41
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">Genre</span>
                      <br />
                      <span className="font-bold text-[#49628b]">Femme</span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Condition
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        Chirurgie de perte de poids
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Approbation
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">7 jours</span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Durée de la demande
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        35 minutes
                      </span>
                    </p>

                    <p>
                      <span className="text-gray-500 font-medium">
                        Discussion &amp; réunion
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        50 minutes
                      </span>
                    </p>
                  </div>
                </div>

                {/* Image */}
                <div className="mt-6 bg-white rounded-[22px] p-2 shadow-sm">
                  <div className="rounded-[18px] overflow-hidden">
                    <img
                      loading="lazy"
                      src={img49}
                      alt="Client 2"
                      className="w-full h-[240px] sm:h-[270px] md:h-[300px] object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 2 */}
      <section className="py-20 bg-[#f1f8ff] text-gray-900">
        <div className={siteContainer}>
          <div className="mb-8">
            <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-6 py-2 rounded-full">
              Étude de cas 2
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
            {/* Left side text */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              <p className="text-sm sm:text-base text-[#49628b] leading-relaxed mb-6">
                Un jeune couple,{" "}
                <span className="font-bold">
                  tous deux non-fumeurs en bonne santé, âgés de 30 et 32 ans
                </span>
                , sont impatients de fonder leur nouvelle famille dans leur
                nouvelle maison.
              </p>

              <div className="bg-white rounded-[2rem] shadow-md px-6 sm:px-8 py-6 sm:py-8 text-sm sm:text-base text-[#49628b] leading-relaxed">
                <p className="mb-6 leading-relaxed">
                  <span className="font-bold block mb-2">Préoccupation :</span>
                  <span>
                    S'assurer d'avoir une protection financière en cas
                    d'événement{" "}
                    <span className="font-bold text-[#49628b]">
                      imprévu.
                    </span>
                  </span>
                </p>

                <div className="leading-relaxed">
                  <span className="font-bold block mb-2">Analyse des besoins :</span>

                  <div className="space-y-2">
                    <p>
                      Besoins en assurance-vie à court terme couvrant le
                      prêt hypothécaire et les prêts bancaires :{" "}
                      <span className="font-bold text-[#49628b]">
                        350 000 $ chacun
                      </span>
                    </p>

                    <p>
                      Besoins en assurance-vie à long terme couvrant les frais
                      funéraires et les dépenses finales :{" "}
                      <span className="font-bold text-[#49628b]">
                        50 000 $ chacun
                      </span>
                    </p>

                    <p>
                      Besoin de protection du revenu en cas de diagnostic de
                      maladie grave :{" "}
                      <span className="font-bold text-[#49628b]">
                        50 000 $ chacun
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right side image */}
            <div className="rounded-[2rem] overflow-hidden bg-white shadow-md">
              <img
                loading="lazy"
                src={img50}
                alt="Jeune couple assis ensemble sur un canapé"
                className="w-full h-[260px] sm:h-[300px] md:h-[340px] object-cover"
              />
            </div>
          </div>

          {/* table image */}
          <div className="mt-16">
            <div className="max-w-4xl mx-auto rounded-[2rem] overflow-hidden shadow-md bg-[#415a9c]">
              <img
                loading="lazy"
                src={img51}
                alt="Tableau de couverture pour l'étude de cas 2"
                className="w-full h-auto object-contain"
              />
            </div>

            <p className="mt-8 text-sm sm:text-base leading-relaxed text-[#49628b] max-w-4xl mx-auto">
              Les prix peuvent augmenter ou diminuer selon le fournisseur
              d'assurance concerné. À l'approche de la retraite, le besoin de
              protection d'assurance peut diminuer pour les clients, qui
              pourraient plutôt avoir besoin de liquidités. Pour répondre à ce
              besoin, les clients peuvent choisir de racheter leur police et de
              recevoir la valeur de rachat disponible (VRC) à l'âge de 65 ans.
            </p>
          </div>
        </div>
      </section>

      {/* CASE STUDY 3 */}
      <section className="py-20 bg-[#415a9c] text-gray-900">
        <div className={siteContainer}>
          <div className="text-center mb-10">
            <span className="inline-block bg-white text-[#49628b] font-semibold text-lg sm:text-xl px-8 py-3 rounded-full shadow-md">
              Étude de cas 3
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-stretch">
            {/* LEFT CARD */}
            <div className="bg-[#f4fbff] rounded-[2.5rem] px-6 sm:px-8 pt-8 pb-10 flex flex-col">
              <div className="inline-block bg-[#00c6ff] text-white font-bold px-8 py-2 rounded-full mb-6">
                Client
              </div>

              <div className="flex flex-col flex-1">
                {/* White box */}
                <div className="bg-white rounded-[1.5rem] px-6 sm:px-8 py-6 sm:py-7 shadow-md flex-1">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3 text-sm sm:text-base text-[#49628b]">
                    <p>
                      <span className="font-semibold text-gray-600">Âge</span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg">
                        35
                      </span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Condition
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">Diabétique</span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Approbation
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">7 jours</span>
                    </p>
                  </div>

                  <div className="mt-6 text-sm sm:text-base text-[#49628b]">
                    <p className="font-semibold text-gray-600 mb-1">
                      Analyse des besoins
                    </p>
                    <p className="font-bold text-[#49628b]">
                      Assurance-vie sans examen médical souscrite
                    </p>
                  </div>
                </div>

                <div className="mt-6 rounded-[1.75rem] border-[6px] border-[#1e8bcf] overflow-hidden">
                  <img
                    loading="lazy"
                    src={img53}
                    alt="Client masculin diabétique"
                    className="w-full h-[220px] sm:h-[240px] md:h-[260px] object-cover"
                  />
                </div>
              </div>
            </div>

            {/* RIGHT CARD */}
            <div className="bg-[#f4fbff] rounded-[2.5rem] px-6 sm:px-8 pt-8 pb-10 flex flex-col">
              <div className="inline-block bg-[#00c6ff] text-white font-bold px-8 py-2 rounded-full mb-6">
                Client
              </div>

              <div className="flex flex-col flex-1">
                {/* White box */}
                <div className="bg-white rounded-[1.5rem] px-6 sm:px-8 py-6 sm:py-7 shadow-md flex-1">
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-x-4 gap-y-3 text-sm sm:text-base text-[#49628b]">
                    <p>
                      <span className="font-semibold text-gray-600">Âge</span>
                      <br />
                      <span className="font-bold text-[#49628b] text-lg">
                        35
                      </span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Genre
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">Femme</span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Approbation
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">10 jours</span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Condition
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">Diabétique</span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Durée de la demande
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        40 minutes
                      </span>
                    </p>
                    <p>
                      <span className="font-semibold text-gray-600">
                        Discussion &amp; réunion
                      </span>
                      <br />
                      <span className="font-bold text-[#49628b]">
                        45 minutes
                      </span>
                    </p>
                  </div>
                </div>

                <div className="mt-6 rounded-[1.75rem] border-[6px] border-[#1e8bcf] overflow-hidden">
                  <img
                    loading="lazy"
                    src={img54}
                    alt="Cliente féminine diabétique"
                    className="w-full h-[220px] sm:h-[240px] md:h-[260px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 4 */}
      <section className="py-20 bg-[#f1f8ff] text-gray-900">
        <div className={`${siteContainer} relative`}>
          <div className="mb-8">
            <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-6 py-2 rounded-full">
              Étude de cas 4
            </span>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10">
            {/* Left text */}
            <div>
              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
                Diagnostiqué avec la sclérose en plaques il y a 7 ans
              </p>

              <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[2.5rem] px-8 py-5 mb-8 max-w-xl text-sm sm:text-base leading-relaxed">
                Assurance-vie sans examen médical approuvée par
                <br />
                une compagnie d'assurance-vie cotée A
              </div>

              {/* Details */}
              <div className="space-y-3 text-sm sm:text-base text-[#49628b]">
                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">Âge :</span>{" "}
                  <span className="font-bold">35</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Genre :
                  </span>{" "}
                  <span className="font-bold">Homme</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-bold">Non-fumeur</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Condition :
                  </span>{" "}
                  <span className="font-bold">Sclérose en plaques chronique</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Durée de la demande :
                  </span>{" "}
                  <span className="font-bold">40 minutes</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Révision et discussion :
                  </span>{" "}
                  <span className="font-bold">50 minutes</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Approbation après soumission :
                  </span>{" "}
                  <span className="font-bold">6 jours</span>
                </p>
              </div>
            </div>

            {/* Right image */}
            <div className="rounded-[2.5rem] overflow-hidden bg-white shadow-md">
              <img
                loading="lazy"
                src={img52}
                alt="Client atteint de sclérose en plaques"
                className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 5 */}
      <section className="py-20 text-gray-900">
        <div className={siteContainer}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* LEFT IMAGE */}
            <div className="rounded-[2.5rem] overflow-hidden bg-white shadow-md">
              <img
                loading="lazy"
                src={img55}
                alt="Client diabétique nécessitant de l'insuline"
                className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
              />
            </div>

            {/* RIGHT Text */}
            <div>
              <div className="mb-6">
                <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-7 py-2 rounded-full">
                  Étude de cas 5
                </span>
              </div>

              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
                Incapable d'obtenir une assurance en raison d'un diabète
                nécessitant de l'insuline.
              </p>

              <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[2.5rem] px-8 py-5 mb-8 max-w-xl text-sm sm:text-base leading-relaxed">
                Assurance-vie sans examen médical APPROUVÉE en 5 jours !
                <br />
                Félicitations à notre client !
              </div>

              {/* Details */}
              <div className="space-y-3 text-sm sm:text-base text-[#49628b]">
                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">Âge :</span>{" "}
                  <span className="font-bold">44</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Genre :
                  </span>{" "}
                  <span className="font-bold">Homme</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-bold">Non-fumeur</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Condition :
                  </span>{" "}
                  <span className="font-bold">
                    Diagnostiqué avec le diabète il y a plus de 11 ans.
                  </span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Durée de la demande :
                  </span>{" "}
                  <span className="font-bold">45 minutes</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Révision et discussion :
                  </span>{" "}
                  <span className="font-bold">45 minutes</span>
                </p>

                <p>
                  <span className="mr-2 text-[#49628b]">▶</span>
                  <span className="font-semibold text-gray-700">
                    Approbation après soumission :
                  </span>{" "}
                  <span className="font-bold">5 jours</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 6 SECTION */}
      <section className="relative py-20 bg-[#f1f8ff] text-gray-900 overflow-hidden">
        <div
          className={`relative ${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT TEXT */}
          <div className="z-10">
            <div className="mb-6">
              <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-7 py-2 rounded-full">
                Étude de cas 6
              </span>
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>

            <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
              John &amp; Cynthia ont souscrit une assurance hypothécaire auprès d'une banque
            </p>
            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              <ul className="list-disc ml-5 space-y-1">
                <li>Primes élevées</li>
                <li>Ne pouvaient pas mettre à jour les bénéficiaires sans l'approbation de la banque</li>
                <li>
                  Ont subi des délais de 3 mois juste pour modifier les détails
                  de la police après avoir eu un enfant
                </li>
              </ul>
            </div>

            <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
              Ils ont consulté un conseiller en assurance hypothécaire privée et
              ont changé de fournisseur.
            </p>

            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              <ul className="list-disc ml-5 space-y-1">
                <li>Ils sont devenus propriétaires de la police</li>
                <li>Pouvaient mettre à jour les bénéficiaires instantanément</li>
                <li>Primes fixes et réduites</li>
                <li>La couverture reste intacte même s'ils changent de prêteur</li>
              </ul>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative rounded-[2.5rem] overflow-hidden bg-white shadow-md">
            <img
              loading="lazy"
              src={img56}
              alt="John et Cynthia avec leur famille"
              className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
            />
          </div>
        </div>
      </section>

      {/* CASE STUDY 7 */}
      <section className="py-20 text-gray-900">
        <div
          className={`${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT IMAGE */}
          <div className="rounded-[2.5rem] overflow-hidden bg-white shadow-md">
            <img
              loading="lazy"
              src={img57}
              alt="David le camionneur"
              className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div>
            <div className="mb-6">
              <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-7 py-2 rounded-full">
                Étude de cas 7
              </span>
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>

            <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
              David, camionneur de 35 ans, travailleur autonome
            </p>

            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              David a glissé en déchargeant des marchandises et a subi une grave
              blessure à la colonne vertébrale. Incapable de travailler, ses
              revenus se sont arrêtés du jour au lendemain.
            </div>

            <div className="space-y-5 text-sm sm:text-base leading-relaxed">
              <p>
                <span className="font-bold text-[#1f2933]">
                  Pas de revenu, pas d'économies :
                </span>{" "}
                <span className="text-black">
                  Sans assurance invalidité, les économies de David se sont
                  épuisées. Les factures s'accumulaient et sa femme a dû prendre
                  un travail supplémentaire. Avec une couverture invalidité, il
                  aurait pu recevoir des prestations mensuelles.
                </span>
              </p>

              <p>
                <span className="font-bold text-[#1f2933]">
                  Protégez votre avenir avant qu'il ne soit TROP TARD !{" "}
                </span>
                L'histoire de David est un rappel : la vie est imprévisible.
                L'assurance invalidité assure une stabilité financière quand
                vous ne pouvez pas travailler.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 8 */}
      <section className="py-20 bg-[#f1f8ff] text-gray-900">
        <div
          className={`${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT CONTENT */}
          <div>
            <div className="mb-6">
              <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-7 py-2 rounded-full">
                Étude de cas 8
              </span>
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>

            <p className="text-sm sm:text-base font-bold text-[#1f2933] mb-5">
              A souscrit une assurance Deferred Elite Terme-10 avec une couverture
              de 100 000 $, décédé.
            </p>

            {/* Blue info box */}
            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              Prestation de décès intégralement versée après évaluation
            </div>

            {/* List */}
            <div className="space-y-3 text-sm sm:text-base text-[#49628b]">
              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-semibold text-gray-700">Âge :</span>{" "}
                <span className="font-bold">35</span>
              </p>

              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-semibold text-gray-700">
                  Genre :
                </span>{" "}
                <span className="font-bold">Homme</span>
              </p>

              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-bold">Non-fumeur</span>
              </p>

              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-semibold text-gray-700">
                  Documents requis :
                </span>{" "}
                <span className="font-bold">
                  Évaluation du réclamant, SAP, rapport du coroner
                </span>
              </p>

              <p>
                <span className="mr-2 text-[#49628b]">▶</span>
                <span className="font-semibold text-gray-700">
                  Décision de réclamation :
                </span>{" "}
                <span className="font-bold">Intégralement versée</span>
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="rounded-[2.5rem] overflow-hidden bg-white shadow-md">
            <img
              loading="lazy"
              src={img58}
              alt="Famille examinant des documents après une réclamation d'assurance"
              className="w-full h-[260px] sm:h-[320px] md:h-[360px] object-cover"
            />
          </div>
        </div>
      </section>

      {/* CASE STUDY 9 SECTION */}
      <section className="py-16">
        <div
          className={`${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT: IMAGE */}
          <div className="order-1">
            <div className="rounded-[2rem] overflow-hidden shadow-md">
              <img
                loading="lazy"
                src={img59}
                alt="Raj et Simran avec leur enfant"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* RIGHT CONTENT */}
          <div className="order-2">
            <div className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-8 py-3 rounded-full mb-4">
              Étude de cas 9
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>
            <p className="text-sm sm:text-base text-gray-800 mb-6">
              Raj (32) et Simran (29), parents d'un enfant de 2 ans. Revenu du
              ménage :
              <span className="font-semibold text-[#49628b]"> 85 000 $.</span>
            </p>

            {/* Blue Info Box */}
            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              <p className="text-sm sm:text-base leading-relaxed">
                Ils voulaient une assurance-vie mais s'inquiétaient de
                l'accessibilité financière avec les frais de garderie et les
                dépenses hypothécaires.
              </p>
            </div>

            {/* Solution */}
            <div className="flex items-start gap-3 mb-4">
              <span className="text-[#49628b] text-lg leading-relaxed">▶</span>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                <span className="font-semibold text-[#49628b]">Solution : </span>
                Nous avons comparé des polices auprès de plusieurs fournisseurs
                et avons obtenu une police d'assurance-vie à terme de 20 ans
                pour Raj à seulement{" "}
                <span className="font-semibold text-[#49628b]">
                  28 $/mois
                </span>{" "}
                et Simran à{" "}
                <span className="font-semibold text-[#49628b]">21 $/mois.</span>
              </p>
            </div>

            {/* Outcome */}
            <div className="flex items-start gap-3">
              <span className="text-[#49628b] text-lg leading-relaxed">▶</span>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                <span className="font-semibold text-[#49628b]">Résultat : </span>
                Pour moins de{" "}
                <span className="font-semibold text-[#49628b]">50 $/mois</span>,
                la famille bénéficie d'une couverture de{" "}
                <span className="font-semibold text-[#49628b]">500 000 $</span>{" "}
                chacun, garantissant l'avenir de leur enfant même en cas
                d'imprévu.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 10 SECTION */}
      <section className="bg-[#f5fbff] py-16">
        <div
          className={`${siteContainer} grid grid-cols-1 lg:grid-cols-2 gap-12 items-center`}
        >
          {/* LEFT CONTENT */}
          <div className="order-2 lg:order-1">
            <div className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-8 py-3 rounded-full mb-4">
              Étude de cas 10
            </div>

            <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
              Client
            </h3>

            <p className="text-sm sm:text-base text-gray-800 mb-6 font-semibold">
              Professionnel indépendant :{" "}
              <span className="text-[#49628b] font-bold">Amandeep (40)</span>,
              possède une entreprise de camionnage, revenu d'environ{" "}
              <span className="text-[#49628b] font-bold">120 000 $ / an.</span>
            </p>

            {/* Blue Info Box */}
            <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
              <p className="text-sm sm:text-base leading-relaxed">
                Pas d'avantages sociaux, souhaitait une couverture qui
                accumule également des liquidités pour la retraite.
              </p>
            </div>

            {/* Solution */}
            <div className="flex items-start gap-3 mb-4">
              <span className="text-[#49628b] text-lg leading-relaxed">▶</span>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                <span className="font-semibold text-[#49628b]">Solution :</span>{" "}
                Nous avons recommandé un plan{" "}
                <span className="font-semibold text-[#49628b]">
                  d'assurance-vie entière
                </span>{" "}
                qui offre une protection à vie ainsi qu'une croissance de la
                valeur de rachat.
              </p>
            </div>

            {/* Outcome */}
            <div className="flex items-start gap-3">
              <span className="text-[#49628b] text-lg leading-relaxed">▶</span>
              <p className="text-sm sm:text-base text-gray-800 leading-relaxed">
                <span className="font-semibold text-[#49628b]">Résultat :</span>{" "}
                Amandeep a maintenant la tranquillité d'esprit en sachant que
                sa famille est protégée, tout en constituant une réserve
                financière qu'il pourra utiliser ultérieurement pour
                l'expansion de son entreprise ou la planification de sa retraite.
              </p>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="order-1 lg:order-2">
            <div className="rounded-[2rem] overflow-hidden shadow-md">
              <img
                loading="lazy"
                src={img60}
                alt="Amandeep, propriétaire d'une entreprise de camionnage indépendante"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 11 */}
      <section className="py-16 sm:py-20">
        <div className={siteContainer}>
          <div className="flex flex-col lg:flex-row items-stretch gap-10">
            {/* LEFT IMAGE */}
            <div className="flex-1 rounded-[2.5rem] overflow-hidden shadow-md">
              <img
                loading="lazy"
                src={img61}
                alt="Harpreet, approchant de la retraite, debout avec un livre"
                className="w-full h-full object-cover"
              />
            </div>

            {/* RIGHT CONTENT */}
            <div className="flex-1 flex flex-col justify-center">
              <div className="mb-4">
                <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-8 py-3 rounded-full shadow-sm">
                  Étude de cas 11
                </span>
              </div>

              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              <p className="text-sm sm:text-base md:text-lg font-semibold text-[#143451] mb-6">
                Harpreet (55), approchant de la retraite, avec une maison
                remboursée et 2 enfants adultes.
              </p>

              {/* Blue info box */}
              <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
                <p className="text-sm sm:text-base leading-relaxed">
                  N'avait pas besoin de remplacement de revenu mais souhaitait
                  couvrir les dépenses finales et laisser un héritage libre
                  d'impôt.
                </p>
              </div>

              <div className="mt-6 space-y-4 text-sm sm:text-base text-[#1f2a3d]">
                {/* Solution */}
                <div className="flex items-start gap-2">
                  <span className="text-[#49628b] text-lg leading-relaxed">
                    ▶
                  </span>
                  <p>
                    <span className="font-semibold">Solution :</span> Une police
                    d'assurance-vie permanente pour 250 000 $. Primes :
                    190 $/mois.
                  </p>
                </div>

                {/* Outcome */}
                <div className="flex items-start gap-2">
                  <span className="text-[#49628b] text-lg leading-relaxed">
                    ▶
                  </span>
                  <p>
                    <span className="font-semibold">Résultat :</span> Versement
                    garanti libre d'impôt à ses enfants, ainsi que la
                    tranquillité d'esprit de savoir que les frais de succession
                    seront couverts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CASE STUDY 12 SECTION */}
      <section className="bg-[#f4fbff] py-16 sm:py-20">
        <div className={siteContainer}>
          <div className="flex flex-col lg:flex-row items-stretch gap-10">
            {/* LEFT CONTENT */}
            <div className="flex-1 flex flex-col justify-center">
              <div className="mb-4">
                <span className="inline-block bg-[#00c6ff] text-white font-semibold text-lg sm:text-xl px-8 py-3 rounded-full shadow-sm">
                  Étude de cas 12
                </span>
              </div>

              <h3 className="text-base sm:text-lg font-bold text-[#49628b] mb-3">
                Client
              </h3>

              {/* Client details */}
              <p className="text-sm sm:text-base md:text-lg font-semibold text-[#143451] mb-6">
                M. et Mme Sharma, tous deux âgés de 62 ans, en visite chez
                leur fils à Brampton.
              </p>

              <div className="bg-gradient-to-r from-[#1e72c0] to-[#415a9c] text-white rounded-[1.5rem] px-8 py-5 mb-8 max-w-lg text-sm sm:text-base leading-relaxed">
                <p className="text-sm sm:text-base leading-relaxed">
                  Avaient besoin d'une assurance Super Visa pour 2 ans mais
                  étaient dépassés par les coûts élevés.
                </p>
              </div>

              <div className="space-y-4 text-sm sm:text-base text-[#143451]">
                {/* Solution */}
                <div className="flex items-start gap-2">
                  <span className="text-[#49628b] text-lg leading-relaxed">
                    ▶
                  </span>
                  <p>
                    <span className="font-semibold">Solution :</span> Nous avons
                    comparé plus de 8 assureurs et avons trouvé une police
                    remboursable avec une couverture médicale de 100 000 $,
                    avec une option de paiement mensuel.
                  </p>
                </div>

                {/* Outcome */}
                <div className="flex items-start gap-2">
                  <span className="text-[#49628b] text-lg leading-relaxed">
                    ▶
                  </span>
                  <p>
                    <span className="font-semibold">Résultat :</span> Économies
                    de près de 1 200 $ par rapport au devis de leur banque,
                    avec des paiements flexibles. Ils sont entrés au Canada sans
                    stress, sachant que les urgences médicales sont couvertes.
                  </p>
                </div>
              </div>
            </div>

            {/* RIGHT IMAGE */}
            <div className="flex-1 rounded-[2.5rem] overflow-hidden shadow-md">
              <img
                loading="lazy"
                src={img62}
                alt="M. et Mme Sharma souriant ensemble"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Interested in discussing your specific needs? */}
      <section className="bg-[#f4fbff] py-20 sm:py-24">
        <div className={siteContainer}>
          {/* Blue Gradient Box */}
          <div className="bg-gradient-to-r from-[#1e48a0] to-[#00c6ff] rounded-[2rem] p-8 sm:p-10 text-center text-white shadow-md">
            <h2 className="text-2xl sm:text-3xl font-bold mb-4">
              Intéressé à discuter de vos besoins spécifiques ?
            </h2>

            <p className="text-base sm:text-lg max-w-2xl mx-auto mb-8 leading-relaxed text-white/90">
              Prenez rendez-vous aujourd'hui pour une revue complète de votre
              assurance et découvrez comment nous pouvons adapter nos solutions
              à vos défis uniques.
            </p>

            {/* Contact Button */}
            {/* Contact Button */}
            <Link
              to="/fr/prendre-rendez-vous"
              className="bg-[#00b4ff] hover:bg-[#009de6] text-white font-semibold px-8 py-3 rounded-full shadow-md transition-all w-full sm:w-auto text-base sm:text-lg"
            >
              Contactez-nous
            </Link>

            <div className="mt-10 rounded-[2rem] overflow-hidden border-[6px] border-white shadow-lg bg-white">
              <img
                loading="lazy"
                src={img63}
                alt="Consultation d'assurance en famille heureuse"
                className="block w-full h-full object-cover -mt-1"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CaseStudies;
